import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"width":"100%","margin":"0 auto","padding":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }